import React, { FC, ReactNode } from "react";
import { ToggleSwitch } from "@components/ToggleSwitch/ToggleSwitch";
import { OptionalBadge } from "@components/Badges/OptionalBadge";
import { classNames } from "@utils/classNames";

interface Props {
  title: string;
  description?: string;
  hasToggle?: boolean;
  isToggled?: boolean;
  onToggle?(): void;
  children?: ReactNode;
  isLast?: boolean;
}

export const JobPostEditorSectionLayout: FC<Props> = ({
  title,
  description,
  hasToggle = false,
  isToggled = false,
  onToggle = () => {},
  children,
  isLast = false,
}) => (
  <div className={classNames(isLast ? "" : "border-b border-gray-200")}>
    {/* header = title + maybe toggle */}
    {title || hasToggle || description ? (
      <div className="px-4 pt-5 pb-6 sm:px-6">
        <div className="flex justify-between">
          <h3
            className={classNames(
              !hasToggle || isToggled ? "text-black" : "text-gray-300",
              "text-2xl leading-6 font-bold"
            )}
          >
            {title} {hasToggle && <OptionalBadge />}
          </h3>
          {hasToggle && (
            <ToggleSwitch checked={isToggled} onChange={onToggle} />
          )}
        </div>
        {description && (
          <p className="mt-1 text-sm text-gray-400">{description}</p>
        )}
      </div>
    ) : (
      <div className="mt-4"></div>
    )}
    {/* content */}
    {(!hasToggle || isToggled) && (
      <div className="px-4 pb-7 sm:px-6">{children}</div>
    )}
  </div>
);
